
import { Component, OnInit, Inject } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { ControlFactoryDirective } from '@s-shared/directives/control-factory.directive';

@Component({
    selector: 'app-dialog-container',
    templateUrl: './dialog-container.component.html',
    styleUrls: ['./dialog-container.component.scss'],
    imports: [
    ControlFactoryDirective
]
})
export class DialogContainerComponent implements OnInit {
  data: Record<string, unknown>;

  constructor(
    private dialogRef: MatDialogRef<DialogContainerComponent>,
    @Inject(MAT_DIALOG_DATA) public dialogData: Record<string, unknown>,
  ) {
    this.data = { ...dialogData, containerRef: dialogRef, refType: 'dialog' };
  }

  ngOnInit() {
  }

}
